import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import LoginScreen from "../containers/auth/screens/LoginScreen";
import LogOut from "../containers/auth/LogOut";
import PrivateRoute from "../containers/auth/PrivateRoute";
import DashboardScreen from "../containers/dashboard/screens/DashboardScreen";
import ConfirmacionScreen from "../containers/dashboard/screens/ConfirmacionScreen";
import AutorizacionScreen from "../containers/autorizacion/screens/AutorizacionScreen";
import DetalleAutorizacionScreen from "../containers/autorizacion/screens/DetalleAutorizacionScreen";
import VoucherScreen from "../containers/autorizacion/screens/VoucherScreen";
import VoucherGmmScreen from "../containers/autorizacion/screens/VoucherGmmScreen";
import BusquedaAutorizacionScreen from "../containers/autorizacion/screens/BusquedaAutorizacionScreen";
import ConfirmarPrecertificacionScreen from "../containers/precertificacion/screens/ConfirmarPrecertificacionScreen";
import CancelarPrecertificacionScreen from "../containers/precertificacion/screens/CancelarPrecertificacionScreen";
import CierreCuentasScreen from "../containers/ingreso/screens/CierreCuentasScreen";
import DetalleCierreCuentaScreen from "../containers/ingreso/screens/DetalleCierreCuentaScreen";
import VoucherCierreCuentaScreen from "../containers/ingreso/screens/VoucherCierreCuentaScreen";
import VoucherHonorariosScreen from "../containers/ingreso/screens/VoucherHonorariosScreen";
import BusquedaCierresCuentasScreen from "../containers/ingreso/screens/BusquedaCierresCuentasScreen";

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/login">
        <LoginScreen />
      </Route>
      <Route path="/logout">
        <LogOut />
      </Route>
      <PrivateRoute path="/dashboard" component={DashboardScreen} />
      <PrivateRoute path="/confirmacion" component={ConfirmacionScreen} />
      <PrivateRoute path="/autorizacion" component={AutorizacionScreen} />
      <PrivateRoute
        path="/detalle-autorizacion"
        component={DetalleAutorizacionScreen}
      />
      <PrivateRoute path="/voucher" component={VoucherScreen} />
      <PrivateRoute path="/voucher-gmm" component={VoucherGmmScreen} />
      <PrivateRoute
        path="/busqueda-autorizacion"
        component={BusquedaAutorizacionScreen}
      />
      <PrivateRoute
        path="/confirmar-precertificacion"
        component={ConfirmarPrecertificacionScreen}
      />
      <PrivateRoute
        path="/cancelar-precertificacion"
        component={CancelarPrecertificacionScreen}
      />
      <PrivateRoute path="/cierre-cuentas" component={CierreCuentasScreen} />
      <PrivateRoute
        path="/detalle-cierre-cuenta"
        component={DetalleCierreCuentaScreen}
      />
      <PrivateRoute
        path="/voucher-cierre-cuenta"
        component={VoucherCierreCuentaScreen}
      />
      <PrivateRoute
        path="/voucher-honorarios"
        component={VoucherHonorariosScreen}
      />
      <PrivateRoute
        path="/busqueda-cierres-cuentas"
        component={BusquedaCierresCuentasScreen}
      />
      <Route path="/">
        <Redirect to="/login" />
      </Route>
    </Switch>
  );
}
